import { render, staticRenderFns } from "./wv-enable-ai-assist.vue?vue&type=template&id=186b370f&scoped=true&"
import script from "./wv-enable-ai-assist.vue?vue&type=script&lang=js&"
export * from "./wv-enable-ai-assist.vue?vue&type=script&lang=js&"
import style0 from "./wv-enable-ai-assist.vue?vue&type=style&index=0&id=186b370f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b370f",
  null
  
)

export default component.exports